import { useMemo } from 'react'
import * as Yup from 'yup'

import { useTranslation } from '../../../../../../../app/_providers/TranslationProvider.client'
import { allowedIconTextInputCharactersPattern } from '../../../../../../../brunswick/containers/embroidery/utils'

export function useValidationSchema({ initialsMaxChars }: { initialsMaxChars: number }) {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['IconFormValues']),
      iconPlacement: Yup.object()
        .shape({})
        .required(fixtures.validationErrorMessages.requiredIconPlacement),
      initials: Yup.string()
        .matches(
          allowedIconTextInputCharactersPattern,
          fixtures.validationErrorMessages.allowedInitialsTextCharacters
        )
        .max(
          initialsMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            initialsMaxChars.toString()
          )
        ),
      initialsColor: Yup.string().when('initials', {
        is: (initials: string) => !!initials && !!initials.trim(),
        then: Yup.string().required(fixtures.validationErrorMessages.requiredSelection),
      }),
      iconImage: Yup.object().shape({}).required(fixtures.validationErrorMessages.requiredIcon),
    })
  }, [fixtures, initialsMaxChars])

  return validationSchema
}
